import React, { Component } from 'react';
import {Grid, Row, Col} from 'react-bootstrap'
import './cartaMenu.css'


class CartaMenu extends Component {
    constructor(props) {
        super(props);
        this.item = props.item;
        this.precio = props.precio;
        this.tamaño = props.tamaño;
        this.id = props.id;
        this.handleCount = this.handleCount.bind(this)
    }

    handleCount(id, item, precio) {
        this.props.count(id, item, precio)
    }

    render() {
        return (
            <button className="contain" onClick={() => { this.handleCount(this.id, this.item, this.precio) }}>
                            {this.item}<br/>
                            {this.tamaño}
                            <p>s/.  {this.precio}</p>
            </button>
        )
    }
}

export default CartaMenu;